<script setup>
import { Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-vue-next'
import logoLlevo from '../../assets/img/logo-llevo-wordmark.png'
import StoreButtons from './StoreButtons.vue'

const currentYear = new Date().getFullYear()

const legalLinks = [
  { label: 'Privacidad', to: '/privacidad' },
  { label: 'Términos', to: '/terminos' },
  { label: 'Cookies', to: '/cookies' },
  { label: 'Seguridad', to: '/seguridad' }
]

const socials = [
  { label: 'Facebook', href: 'https://www.facebook.com/llevonicaragua', icon: Facebook },
  { label: 'Instagram', href: 'https://www.instagram.com/llevonicaragua/', icon: Instagram },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/llevo-nicaragua/', icon: Linkedin }
]
</script>

<template>
  <footer id="contacto" class="relative scroll-mt-24 bg-[#0a1120] pb-8 pt-16 text-white md:pt-20">
    <div class="container mx-auto px-6 lg:px-12">
      <div class="grid gap-10 border-b border-white/10 pb-12 lg:grid-cols-12 lg:items-start lg:gap-8">

        <!-- Marca -->
        <div class="lg:col-span-7">
          <a href="#inicio" class="inline-flex items-center rounded-xl bg-white px-3 py-2.5" aria-label="LLEVO — Inicio">
            <img :src="logoLlevo" alt="LLEVO" class="h-10 w-auto object-contain">
          </a>

          <p class="mt-6 max-w-md text-sm leading-relaxed text-slate-400">
            Delivery y logística para negocios y personas. Tecnología propia, repartidores verificados
            y seguimiento en tiempo real para que cada entrega llegue segura y a tiempo.
          </p>

          <div class="mt-6">
            <p class="mb-3 text-[10px] font-black uppercase tracking-[0.18em] text-slate-400">Descarga la app</p>
            <StoreButtons />
          </div>
        </div>

        <!-- Contacto -->
        <div class="lg:col-span-5 lg:pl-10">
          <p class="text-[10px] font-black uppercase tracking-[0.18em] text-slate-400">Contacto</p>

          <a
            href="mailto:contacto@llevonicaragua.com"
            class="mt-3 inline-flex items-center gap-2.5 text-lg font-black tracking-tight text-white transition-colors hover:text-[#ff8a4c]"
          >
            <Mail :size="18" class="text-[#f0611e]" />
            contacto@llevonicaragua.com
          </a>

          <p class="mt-3 flex items-center gap-2.5 text-sm text-slate-400">
            <MapPin :size="15" class="text-[#f0611e]" />
            Managua, Nicaragua
          </p>

          <div class="mt-7 flex items-center gap-2.5">
            <a
              v-for="social in socials"
              :key="social.label"
              :href="social.href"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="social.label"
              class="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 bg-white/[0.04] text-slate-400 transition-all hover:-translate-y-0.5 hover:border-[#f0611e]/40 hover:text-[#ff8a4c]"
            >
              <component :is="social.icon" :size="16" />
            </a>
          </div>
        </div>
      </div>

      <!-- Barra inferior -->
      <div class="flex flex-col gap-4 pt-6 text-xs text-slate-400 md:flex-row md:items-center md:justify-between">
        <p>© {{ currentYear }} LLEVO. Todos los derechos reservados.</p>

        <div class="flex flex-wrap items-center gap-x-5 gap-y-2">
          <router-link v-for="link in legalLinks" :key="link.to" :to="link.to" class="transition-colors hover:text-slate-300">
            {{ link.label }}
          </router-link>
        </div>
      </div>
    </div>
  </footer>
</template>
